import { NA_VALUE } from '@yme/common/constants';
import { languageFrameSizeAdapter } from '@yme/utils/common';
import { DEFAULT_LANG } from '@yme/utils/constants';
import { STATUS_CHANGE, STATUS_INIT, STATUS_RELOAD } from '../constants';
import { SIZE_L, SIZE_M, SIZE_S } from './constants';
export function getFrameSizesValue(listOptions, labels) {
    let s;
    let m;
    let l;
    let other;
    listOptions.forEach((item) => {
        const formattedKey = item.toLowerCase();
        if (formattedKey === SIZE_S) {
            s = {
                key: item,
                value: labels.product_frameSizeSmall_label,
            };
        }
        if (formattedKey === SIZE_M) {
            m = {
                key: item,
                value: labels.product_frameSizeMedium_label,
            };
        }
        if (formattedKey === SIZE_L) {
            l = {
                key: item,
                value: labels.product_frameSizeLarge_label,
            };
        }
        const isNotPreparedLabel = formattedKey !== SIZE_S && formattedKey !== SIZE_M && formattedKey !== SIZE_L;
        if (formattedKey === '' ||
            formattedKey === NA_VALUE.toLowerCase() ||
            isNotPreparedLabel ||
            !formattedKey) {
            other = {
                key: item,
                value: item || NA_VALUE,
            };
        }
    });
    const filteredResult = [s, m, l, other].filter((el) => Boolean(el)) || [];
    return filteredResult;
}
// Filter hooks callBacks
function initialFrameSizeFilterOptions({ variantsOfProduct, }) {
    let activeVariant = variantsOfProduct.find((item) => [item.master, item.size].every((i) => i));
    // case if previous condition return 'undefined' for 'activeVariant'
    if (!activeVariant) {
        activeVariant = variantsOfProduct.find((item) => [item.size, item.stock > 0, item.prices.amount > 0].every((i) => i));
    }
    // case if previous condition return 'undefined' for 'activeVariant'
    if (!activeVariant) {
        activeVariant = variantsOfProduct.find((item) => [item.size, item.prices.amount > 0].every((i) => i));
    }
    return activeVariant;
}
function reloadFrameSizeFilterOptions({ sku, variantsOfProduct, }) {
    const activeVariant = variantsOfProduct.find((item) => [item.size, item.sku === sku].every((i) => i));
    return activeVariant;
}
function updateFrameSizeFilterOptions({ size, variantsOfProduct, }) {
    let activeVariant = variantsOfProduct.find((item) => [item.size, item.size === size].every((i) => i));
    // case if previous condition return 'undefined' for 'activeVariant'
    if (!activeVariant) {
        activeVariant = variantsOfProduct.find((item) => [item.size, item.size === size, item.stock > 0, item.prices.amount > 0].every((i) => i));
    }
    // case if previous condition return 'undefined' for 'activeVariant'
    if (!activeVariant) {
        activeVariant = variantsOfProduct.find((item) => [item.size, item.size === size, item.prices.amount > 0].every((i) => i));
    }
    return activeVariant;
}
// Helper for hook for define filter options: for Frame Size
export function prepareFrameSizeFilterOptions({ colorVariants, index, size = '', sku = '', statusType, }) {
    const commonProps = {
        colorItemIndex: index,
        colourId: colorVariants[index]?.colourId,
        productType: colorVariants[index]?.productType,
    };
    const variantsOfProduct = colorVariants[index]?.variantsOfProduct;
    if (variantsOfProduct) {
        let activeVariant;
        if (statusType === STATUS_INIT && !sku && !size) {
            activeVariant = initialFrameSizeFilterOptions({
                variantsOfProduct,
            });
        }
        if (statusType === STATUS_RELOAD && sku && !size) {
            activeVariant = reloadFrameSizeFilterOptions({
                variantsOfProduct,
                sku,
            });
        }
        if (statusType === STATUS_CHANGE && sku && size) {
            activeVariant = updateFrameSizeFilterOptions({
                variantsOfProduct,
                sku,
                size,
            });
        }
        // Last case - return any first variant (with has positive results with available size) by current ColorGroup
        if (!activeVariant) {
            activeVariant = variantsOfProduct.find((item) => Boolean(item.size));
        }
        return {
            ...commonProps,
            sku: activeVariant?.sku || '',
            size: activeVariant?.size || '',
        };
    }
    return {
        ...commonProps,
        sku: '',
        size: '',
    };
}
export function adaptLangValue(value = DEFAULT_LANG) {
    const currentValue = value.replace('_', '-').toLowerCase();
    const result = languageFrameSizeAdapter[currentValue];
    return result || DEFAULT_LANG;
}
